import React from 'react'
import type { TasksPerProjectProviderProps } from './Context'
import { TasksPerProjectProvider } from './Context'
import { Layout } from './Layout'

export const TasksPerProject = (props: Omit<TasksPerProjectProviderProps, 'children'>) => {
  return (
    <TasksPerProjectProvider {...props}>
      <Layout />
    </TasksPerProjectProvider>
  )
}
